import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {logsApi} from '../http/Api';

export const getAllLogs = createAsyncThunk('Logs/getAllLogs', async (_, thunkAPI) => {
  const {serverId} = thunkAPI.getState().serverId;
  const response = await logsApi.getAllLogs(serverId);
  console.log('response', response);

  if (response.status === 200) {
    thunkAPI.dispatch(logsSlice.actions.setAllLogs(response));
  }
});

const initialState = {
  allLogsState: null,
};

const logsSlice = createSlice({
  name: 'allLogs',
  initialState,
  reducers: {
    setAllLogs: (state, action) => {
      state.allLogsState = action.payload;
    },
  },
});

export const allLogs = logsSlice.reducer;
